













































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetSysDicBasicList, InsertSysBasic, DeleteSysBasic, UpdateSysBasic} from '../../../api/configureDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
import CONFIGS from '../../../../public/configInit.js'

@Component
export default class Configure extends AbpBase {
	dialog: any = {}
	dialogFormLabelWidth = '100px'
	dialogForm: any = {}
	tree:any [] = []
	treeCopy:any [] = []
	loading = false//页面加载动画
	search = ''
	/**
	 * 定义变量 addButtonClickd 在 treeClick 方法中判断是否点击了新增按钮
	 * 	点击了新增按钮就将 当前行的 showing 设置为 true 展开 chidlist 忽略已展开状态
	*/
	addButtonClickd = false
	treeClick(row: any){
		if (this.addButtonClickd) {
			this.addButtonClickd = false
			row.showing = true
			return
		}
		row.showing = !row.showing
	}
	created() {
		this.getData()
	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialog.title === "新增") {
					let res = await InsertSysBasic(this.dialogForm)
				} else if (this.dialog.title === "编辑") {
					let res = await UpdateSysBasic(this.dialogForm)
				}
				this.dialog.show = false
				this.getData()
			}
		})
	}
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.py = res1
		this.dialogForm.wb = res2
	}
	addChild(row: any){
		this.addButtonClickd = true
		this.dialog = {
			show: true,
			title: "新增"
		}
		this.dialogForm = {
			code: Date.now(),
			parentId: row.id,
			py:'',
			wb:''
		}

	}
	@Watch('search')
	searchChange() {
		if (this.search) {
			this.tree = this.treeCopy.filter((item: any, index: number) => {
				item.showing = true
				return item.name.indexOf(this.search) !== -1
			})
		} else {
			this.tree = this.treeCopy.map((item: any, index: number) => {
				item.showing = false
				return item
			})
		}
	}
	get height() {
		return window.innerHeight - 200
	}
	async deleteChild(row: any){
		this.$confirm('此操作将永久删除该配置项, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteSysBasic({id: row.id})
			this.getData()
			// this.$message({
			// type: 'success',
			// message: '删除成功!'
			// });
		}).catch(() => {
			// this.$message({
			// type: 'info',
			// message: '已取消删除'
			// });
		});

	}
	editChild(row: any){
		this.dialog = {
			show: true,
			title: "编辑"
		}
		this.dialogForm = Object.assign({}, row)
	}
	private async getData(){
		this.loading = true
		let res = await GetSysDicBasicList({})
		// 自动生成配置项
		if (res.length < CONFIGS.length) {
			for (let i in CONFIGS) {
				if (i >= res.length) {
					let res = await InsertSysBasic(CONFIGS[i])
				}
			}
			this.getData()
		} else {
			res.forEach((item: any) => {
				item.showing = false
			});
			this.tree = res
			this.treeCopy = [...res]
		}
		this.loading = false
	}
	handleClose() {
		(this.$refs.form as any).resetFields()
		this.dialog.show = false
	}
	visibleChange(val: any){
		if (!val) {
			this.dialog.show = false;
			(this.$refs.form as any).resetFields()
		}
	}
	rules = {
		name:[{required: true, message: '请输入内容', trigger: 'blur'}],
		py:[{required: true, message: '请输入内容', trigger: 'blur'}],
		wb:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/configureDictionary/configure/index.vue